import { z } from 'zod';

// ─── Notification types & status ─────────────────────────────────────────────

export const NotificationTypeSchema = z.enum([
  'access_granted',
  'activation_reminder',
  'weekly_summary',
  'admin_broadcast',
]);
export type NotificationType = z.infer<typeof NotificationTypeSchema>;

export const NotificationSendStatusSchema = z.enum(['sending', 'sent', 'skipped', 'failed', 'opened']);
export type NotificationSendStatus = z.infer<typeof NotificationSendStatusSchema>;

// ─── GET/PATCH /notifications/preferences ───────────────────────────────────

export const NotificationPreferencesSchema = z.object({
  broadcastConsent: z.boolean(),
  personalConsent: z.boolean(),
  timezone: z.string().min(1).max(100),
});
export type NotificationPreferences = z.infer<typeof NotificationPreferencesSchema>;

export const UpdateNotificationPreferencesSchema = z
  .object({
    broadcastConsent: z.boolean().optional(),
    personalConsent: z.boolean().optional(),
  })
  .strict();
export type UpdateNotificationPreferencesDto = z.infer<typeof UpdateNotificationPreferencesSchema>;

export const UpdateNotificationTimezoneSchema = z
  .object({
    timezone: z.string().min(1).max(100),
  })
  .strict();
export type UpdateNotificationTimezoneDto = z.infer<typeof UpdateNotificationTimezoneSchema>;

// ─── Web Push subscription contracts ────────────────────────────────────────

export const WebPushSubscriptionKeysSchema = z
  .object({
    p256dh: z.string().min(1),
    auth: z.string().min(1),
  })
  .strict();
export type WebPushSubscriptionKeysDto = z.infer<typeof WebPushSubscriptionKeysSchema>;

export const UpsertWebPushSubscriptionSchema = z
  .object({
    endpoint: z.string().url().max(2048),
    keys: WebPushSubscriptionKeysSchema,
    userAgent: z.string().max(512).optional(),
  })
  .strict();
export type UpsertWebPushSubscriptionDto = z.infer<typeof UpsertWebPushSubscriptionSchema>;

export const WebPushSubscriptionStateSchema = z
  .object({
    enabled: z.boolean(),
    endpoint: z.string().url().nullable(),
  })
  .strict();
export type WebPushSubscriptionState = z.infer<typeof WebPushSubscriptionStateSchema>;
